export interface CompetitorPrice {
  name: string;
  fee: number;
}

export const COMPETITOR_PRICING: CompetitorPrice[] = [
  { name: "Zen Planner", fee: 99 },
  { name: "Mindbody", fee: 129 },
];
